import React from 'react';
import about from '../assests/img/about-home.jpeg';


import img1 from '../assests/img/Image-1.jpg';
import img2 from '../assests/img/Image-2.jpg';
import img3 from '../assests/img/Image-3.jpg';
import img4 from '../assests/img/Image-4.jpg';
import img5 from '../assests/img/Image-5.jpg';
import img6 from '../assests/img/Image-6.jpg';





function Showact() {
  return (
    <>
     
      <section className="show-activity">

        <div className='sec-title'>
          <h2>Show activity</h2>
          <div class="separator"></div>
        </div>

        <div className="container">
          <div className="row-inner">
            <div className='col-md-12 inner-view-gallery-box'>
            <div className='gallery-box'>
              <img src={img1}/>
            </div>
            <div className='gallery-box'>
              <img src={img2}/>
            </div>
            <div className='gallery-box'>
              <img src={img3}/>
            </div>
            <div className='gallery-box'>
              <img src={img4}/>
            </div>           
            </div>

           
          </div>
        </div>
      </section>

    </>
  )

}

export default Showact;
